import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export default function useSettings() {
  const userLocation = useState<UserLocation>('userLocation', () => ({ lat: undefined, lng: undefined, name: '', place_id: '' }))
  const selectedDistance = useState<number | undefined>('selectedDistance', () => undefined)
  const breakpoints = useBreakpoints(breakpointsTailwind, { ssrWidth: 768 })

  const { width } = useWindowSize()
  const isMobile = computed(() => {
    return width.value <= breakpointsTailwind.md
  })

  return {
    userLocation,
    selectedDistance,
    breakpoints,
    isMobile,
  }
}
